import { CoordinatorService } from './coordinator.service';
import { Document } from './document';
import { Notepad } from './notepad';
import { Story } from './story';
import { StoryItem } from './story-item';

type TARGET = Story | Document;

export class Reader$ {
    private _current?: TARGET;

    private _activeNotesItem: StoryItem | undefined;

    constructor(public coords: CoordinatorService) {}

    clear() {
        this._current = undefined;
        this._activeNotesItem = undefined;
    }

    start() {
        if (this._current) this.coords.isReader = true;
        else this.listDialog();

        this.coords.resultList$.markForCheck();
    }

    activate() {
        if (!this._current) {
            if (this.coords.notepad$.current instanceof Notepad)
                this._current = this.coords.notepad$.storyLs[0];
            else this._current = this.coords.notepad$.current;
        }
        this.coords.isReader = true;
    }

    listDialog() {
        this.coords.display$.dialog$.next({
            action: 'reader-list',
        });
    }

    hasCurrent() {
        return !!this._current;
    }

    public get current(): TARGET | undefined {
        return this._current;
    }

    public set current(value: TARGET) {
        this._current = value;
        if (this.current) {
            this.coords.isNotepad = false;
            this.coords.isReader = true;
        }
        this.coords.display$.markForCheck();
    }

    public get activeNotesItem(): StoryItem | undefined {
        return this._activeNotesItem;
    }

    switchNotes(storyItem?: StoryItem) {
        if (!storyItem || this._activeNotesItem === storyItem) this._activeNotesItem = undefined;
        else this._activeNotesItem = storyItem;
        this.coords.display$.markForCheck();
    }
}
